export default __webpack_public_path__ + "static/media/Azure.90eee526.svg";